import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import {
  buildProjectUrlPath,
  ProjectDetailsTabPath,
} from "@repo/app-types/helpers/adminAppRoutes";
import { appPaths } from "../../../../app/appPaths.js";
import { buildCopilotProposalLocation } from "../../../researchAgent/copilotDeepLinks.js";

/** The builder location that replays a proposal's operations into the draft. */
export function buildTrainingProposalEditLocation(props: {
  projectId: string;
  proposalId: CopilotProposalId;
}) {
  return buildCopilotProposalLocation(
    buildProjectUrlPath(
      props.projectId,
      ProjectDetailsTabPath.ProjectConfiguration,
    ),
    props.proposalId,
  );
}

/**
 * The trainings list with the create modal pre-filled from a proposal. A
 * `create_training` proposal has no project until the user creates it, so it
 * cannot open a builder.
 */
export function buildTrainingCreateLocation(props: {
  proposalId: CopilotProposalId;
}) {
  return buildCopilotProposalLocation(
    appPaths.trainings.build(),
    props.proposalId,
  );
}
